
import './index.css';
import Layout from './components/Layout/Layout';
import Products from './components/Shop/Products';

function App() {
  return (
    <Layout>
      <Products />
    </Layout>
  );
}

export default App;
